import React from 'react';
import PropTypes from 'prop-types';
import { Section, StyledActivitiesStats } from './style';
import SubCardActivity from './SubCardActivity';
import { Text } from '../../atoms';
import SubCardSession from './SubCardSession';

const ActivitiesStats = ({ activities = [], isEvent }) => {
  if (!activities?.length > 0) return null;
  return (
    <StyledActivitiesStats>
      {(activities || []).map((section, si) => (
        <Section key={`section-${si}`}>
          {(section?.section_title || section?.title) && (
            <Text type="h3">
              {section?.section_title || section?.title}
              <hr />
            </Text>
          )}
          {(section?.activities || []).map((activity, ai) => {
            if (isEvent) {
              return (
                <SubCardSession
                  key={`activity-${ai}`}
                  activity={activity}
                  activityIndex={ai}
                />
              );
            }
            return (
              <SubCardActivity
                key={`activity-${ai}`}
                activity={activity}
                activityIndex={ai}
              />
            );
          })}
        </Section>
      ))}
    </StyledActivitiesStats>
  );
};

ActivitiesStats.propTypes = {
  activities: PropTypes.array,
  isEvent: PropTypes.bool,
};

export default ActivitiesStats;
